import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { SxProps, Theme } from '@mui/material/styles';
import SingleLineText from '../atoms/SingleLineText';

export interface LoaderSkeletonProps {
  width?: number | string;
  height?: number | string;
  label?: string;
  variant?: 'circular' | 'rectangular' | 'rounded';
  play?: boolean;
  sx?: SxProps<Theme>; // Ajout pour plus de flexibilité
}

// Styled component optimisé - déplacé avant le composant
const StyledLoader = styled('div')<{ sx?: SxProps<Theme> }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  gap: theme.spacing(2),
}));

const LoaderSkeleton = ({
  width = 400,
  height = 600,
  variant = 'rectangular',
  label = 'Chargement des données ...',
  play = true,
  sx,
}: LoaderSkeletonProps) => {
  // Calcul du style une seule fois (optimisation)
  const containerSx: SxProps<Theme> = React.useMemo(
    () => ({
      width,
      height,
      margin: '0 auto',
      ...sx, // Permet de surcharger les styles
    }),
    [width, height, sx],
  );

  return (
    <StyledLoader sx={containerSx}>
      <SingleLineText text={label} />
      <Skeleton animation={play ? 'wave' : false} variant={variant} width={width} height={height} />
    </StyledLoader>
  );
};

export default LoaderSkeleton;
export { LoaderSkeleton };
